import APIService from "@/services/APIService.js";

const apiUsuario = APIService.create({
  baseURL: process.env.VUE_APP_API_URL + "/admin/usuario"
});

export default {
  getAll(limit, page, filters) {
    return apiUsuario.get("", {
      params: {
        limit: limit,
        offset: page * limit - limit,
        sort_by: "nome",
        ...filters
      }
    });
  },
  list() {
    return apiUsuario.get();
  },
  update(id, usuario) {
    return apiUsuario.put("/" + id, usuario);
  },
  create(usuario) {
    return apiUsuario.post("", usuario);
  },
  toggleUsuario(id, toggle) {
    return apiUsuario.post("/"+toggle+"/"+id);
  }
};
